
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/new",
      function () {
        return require("private-next-pages/products/new/index.tsx");
      }
    ]);
  